<template>
  <v-row class="justify-center pt-5">
    <v-slide-x-transition>
      <v-col :cols="viewCols">
        <!-- <ResultStats :result="result" /> -->
        <v-sheet
          :elevation="debugging ? 0 : 4"
          :class="debugging ? null : 'relative scrollable mt-1 h' + height"
          :outlined="results && results.length > 0"
        >
          <v-timeline
            align-top
            dense
            v-if="results && results.length"
          >
            <time-line-result
              v-for="(res, index) in results"
              :key="res.name + index"
              :pos="[index]"
              :result="res"
            />
          </v-timeline>
        </v-sheet>
        <v-progress-linear v-if="loading" rounded color="info" indeterminate>
        </v-progress-linear>
      </v-col>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <v-col :cols="4">
        <ResultStats :result="result" :height="height"/>
      </v-col>
    </v-slide-x-transition>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import TimeLineResult from "./TimeLineResult.vue";
import ResultStats from "./ResultStats.vue";
import { ResultData } from "@/types";

export default Vue.extend({
  components: { TimeLineResult, ResultStats },
  name: "ResultLayout",

  data() {
    return {};
  },
  props: {
    height: VueTypes.number.def(75),
    result: VueTypes.any.def({}),
    debugging: VueTypes.bool.def(false),
    loading: VueTypes.bool.def(false),
  },
  methods: {
    parseError(err: string) {
      if (!err) {
        return { msg: "General error", log: undefined };
      }
      const split = err.split(
        "=========================== logs ==========================="
      );
      return split.length
        ? { msg: split[0], log: split[1] }
        : { msg: err, log: undefined };
    },
    close() {
      this.$emit("close");
    },
  },
  computed: {
    viewCols() {
      return this.debugging ? null : 8;
    },
    results():ResultData[] {
      return this.result.results;
    },
  },
});
</script>
